import { styled } from '@mui/material/styles';

const NativeLink = styled('a')({});

export default NativeLink;
